import {
  collection,
  query,
  where,
  orderBy,
  getDocs
} from 'firebase/firestore';
import { Firestore } from '../Firebase';
import { zoneConverter } from '../model/Zone';

export async function getZones(
  parent: string | null,
  isPrivileged: boolean = false
) {
  const colRef = collection(Firestore, 'zones').withConverter(zoneConverter);
  let q = query(colRef, where('parent', '==', parent))

  if (!isPrivileged) {
    q = query(q, where('public', '==', true));
  }

  q = query(q, orderBy('order'));

  return (await getDocs(q)).docs.map(doc => doc.data());
}

